(function () {
  const Core = window.RB.Core;
  const { equip, empower, buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Brittle Steel": {
      play: [{ op: "kill", to: "$t1" }],
      targets: [{ bind: "t1", spec: { type: "gear" }, prompt: "Kill..." }],
      flowCost: { energy: 4, pips: 1, anyPower: 0, domains: ["fury"] },
    },

    "Death Mark": {
      play: [
        { op: "burn", n: 3 },
        { op: "token", name: "Shadow Clone", n: 1, loc: "base", exhausted: false },
      ],
      flowCost: { energy: 1, pips: 0, anyPower: 2, domains: null },
    },

    "Eclipse Dragon": {
      triggers: [
        {
          on: "move",
          optional: false,
          label: "When I move, if you control 4 or fewer runes, draw 1",
          targets: [],
          program: [{ op: "if", cond: { k: "runesMax", n: 4 }, then: [{ op: "draw", n: 1 }] }],
          self: true,
        },
      ],
    },

    "Pendulum Blade": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["fury"] }),
      ],
      attachedTriggers: [
        {
          on: "move",
          optional: false,
          label: "When I move to a battlefield, give me +2 :rb_might: this turn",
          targets: [],
          program: [buff("source", 2)],
          self: true,
          condSpec: { k: "evToBf" },
        },
      ],
    },

    "Perfect Execution": {
      play: [
        { op: "ready", to: "$t1" },
        { op: "grant", to: "$t1", keyword: "assault", kwValue: 3, dur: "turn" },
      ],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Ready..." }],
      flowCost: { energy: 3, pips: 1, anyPower: 0, domains: ["fury"] },
    },

    "Punching Poro": {
      abilities: [
        empower({ energy: 0, pips: 0, anyPower: 0, domains: null }, { costDiscard: 1 }),
      ],
      selfMightSpecs: [{ n: 1, cond: { k: "selfEmpowered" } }],
    },

    "Renekton, Rage Fueled": {
      triggers: [
        {
          on: "attack",
          optional: false,
          label: "When I attack, if you control 4 or fewer runes, deal 2 to all enemy units here",
          targets: [],
          program: [
            {
              op: "if",
              cond: { k: "runesMax", n: 4 },
              then: [{ op: "deal", n: 2, spec: { type: "unit", here: true, enemy: true } }],
            },
          ],
          self: true,
        },
      ],
    },

    "Shadow Fiend": {
      abilities: [
        empower({ energy: 2, pips: 1, anyPower: 0, domains: ["fury"] }),
      ],
      selfKwSpecs: [{ name: "assault", value: 3, cond: { k: "selfEmpowered" } }],
    },

    "Twilight Reveler": {
      triggers: [
        {
          on: "attack",
          optional: false,
          label: "When I attack, ready another friendly unit",
          targets: [
            {
              bind: "t1",
              spec: { type: "unit", friendly: true, other: true },
              prompt: "Ready...",
            },
          ],
          program: [{ op: "ready", to: "$t1" }],
          self: true,
        },
      ],
    },

    "Rogue Assassin": {
      abilities: [
        empower({ energy: 3, pips: 0, anyPower: 1, domains: null }),
        {
          label: "Move a friendly unit in a showdown to base",
          exhausts: true,
          action: true,
          program: [
            {
              op: "if",
              cond: { k: "myTurn" },
              then: [
                {
                  op: "choose", bind: "u",
                  spec: { type: "unit", friendly: true, inCombat: true },
                  prompt: "Move which friendly unit in a showdown to base?",
                },
                { op: "move", to: "$u", dest: "base" },
                {
                  op: "if",
                  cond: { k: "selfEmpowered" },
                  then: [{ op: "ready", to: "$u" }],
                },
              ],
            },
          ],
        },
      ],
    },

    "Shuriken Flip": {
      targets: [
        {
          bind: "e", spec: { type: "unit", enemy: true, atBf: true },
          min: 0, max: 1,
          prompt: "Deal 2 to up to one enemy unit at a battlefield",
        },
        {
          bind: "f", spec: { type: "unit", friendly: true },
          prompt: "Move which friendly unit?",
        },
      ],
      play: [
        { op: "deal", to: "$e", n: 2 },
        { op: "move", to: "$f" },
      ],
      flowCost: { energy: 3, pips: 0, anyPower: 1, domains: null },
    },

    "Dominus": {
      targets: [
        { bind: "t", spec: { type: "unit" }, prompt: "Double which unit's Might?" },
      ],
      play: [
        { op: "grant", to: "$t", might: { mightOf: "$t" }, dur: "turn" },
        {
          op: "grantAbility", to: "$t", dur: "turn",
          ability: {
            cost: { energy: 0, pips: 0, anyPower: 2, domains: null },
            label: "Ready me",
            action: true,
            program: [{ op: "ready", to: "source" }],
          },
        },
      ],
    },

    "Master of Shadows": {
      triggers: [
        {
          on: "banished", you: true, label: "you banish a card you own: empower me",
          program: [{ op: "empowerSource" }],
        },
      ],
      abilities: [
        {
          label: "Disempower me: discard 1, then draw 1",
          disempowerSelf: true,
          exhausts: true,
          action: true,
          program: [
            { op: "discard", n: 1 },
            { op: "draw", n: 1 },
          ],
        },
      ],
    },

    "Baccai Sandspinner": {
      abilities: [
        empower({ energy: 5, pips: 0, anyPower: 0, domains: null }),
      ],
      selfKwSpecs: [
        { name: "deflect", value: 1, cond: { k: "selfEmpowered" } },
        { name: "assault", value: 2, cond: { k: "selfEmpowered" } },
      ],
      auraCostMod: [{
        ability: { self: true, label: "Empower" },
        cond: { k: "runesMax", n: 4 },
        energyLess: 3,
      }],
    },

    "Blade Twirler": {
      triggers: [
        {
          on: "move",
          self: true,
          oncePerTurn: true,
          label: "first move each turn: a player Burns 1",
          targets: [],
          program: [
            {
              op: "option",
              varKey: "bt",
              prompt: "Which player Burns 1?",
              options: ["You Burn 1", "Your opponent Burns 1"],
            },
            {
              op: "if",
              cond: { k: "varEq", key: "bt", value: 0 },
              then: [{ op: "burn", n: 1 }],
              else: [{ op: "burn", n: 1, who: "opponent" }],
            },
          ],
        },
      ],
    },

    "Dune Surfer": { ignoreTankHere: true },

    "Forsaken Baccai": {
      triggers: [
        {
          on: "beginningPhase",
          you: true,
          condSpec: { k: "runesFewerThanOpp" },
          label: "fewer runes than an opponent: +1 Might this turn",
          targets: [],
          program: [buff("source", 1)],
        },
      ],
    },

    "Oasis Raider": {
      triggers: [
        {
          on: "beginningPhase",
          you: true,
          condSpec: { k: "runesFewerThanOpp" },
          label: "fewer runes than an opponent: +2 Might and [Ganking] this turn",
          targets: [],
          program: [{ op: "grant", to: "source", might: 2, keyword: "ganking", dur: "turn" }],
        },
      ],
    },

    "Ruthless Strike": {
      play: [],
      targets: [
        {
          bind: "t",
          spec: { type: "unit", atBf: true },
          prompt: "Deal damage to which unit at a battlefield?",
        },
      ],
      addCosts: [
        {
          optional: true,
          cond: null,
          label: "Ruthless Strike",
          costDiscard: 1,
          then: [{ op: "deal", to: "$t", n: 5 }],
          otherwise: [{ op: "deal", to: "$t", n: 3 }],
        },
      ],
    },

    "Baccai Reaper": {
      triggers: [
        {
          on: "attack",
          self: true,
          label: "pay 1 Fury for [Assault 2] this turn",
          targets: [],
          program: [
            {
              op: "may",
              prompt: "Pay 1 Fury to give Baccai Reaper [Assault 2] this turn?",
              then: [
                {
                  op: "payCost",
                  cost: { energy: 0, pips: 1, anyPower: 0, domains: ["fury"] },
                  skipOnFail: 1,
                },
                { op: "grant", to: "source", keyword: "assault", kwValue: 2, dur: "turn" },
              ],
            },
          ],
        },
      ],
    },

    "Consuming Curse": {
      targets: [
        {
          bind: "t",
          spec: { type: "unit", atBf: true },
          prompt: "Deal damage to which unit at a battlefield?",
        },
      ],
      play: [{ op: "deal", to: "$t", n: { trashName: true, plus: 2 } }],
    },

    "Shadow Assassin": {
      entersReadyCond: { k: "nameInTrash", n: 1 },
    },

    "Rage Amplifier": {
      abilities: [
        empower({ energy: 6, pips: 1, anyPower: 0, domains: ["fury"] }),
      ],
      auraMightSpecs: [
        { n: 1, who: "friendlyUnits", cond: { k: "not", cond: { k: "selfEmpowered" } } },
        { n: 2, who: "friendlyUnits", cond: { k: "selfEmpowered" } },
      ],
    },

    "Akali, Deadly Weapon": {
      abilities: [
        empower({ energy: 2, pips: 1, anyPower: 0, domains: ["fury"] }),
      ],
      selfMightSpecs: [{ n: 1, cond: { k: "selfEmpowered" } }],
      triggers: [{
        on: "move", self: true, optional: true,
        label: "deal 1 to a unit at a battlefield I moved to or from (2 while Empowered)",
        targets: [{
          bind: "t", spec: { type: "unit", atBf: true, atEvLoc: "either" },
          prompt: "Deal damage to which unit at a battlefield I moved to or from?",
        }],
        program: [{
          op: "if", cond: { k: "selfEmpowered" },
          then: [{ op: "deal", to: "$t", n: 2 }],
          else: [{ op: "deal", to: "$t", n: 1 }],
        }],
      }],
    },

    "Zed, From the Shadows": {
      addCosts: [
        {
          optional: true,
          cond: null,
          label: "Zed, From the Shadows",
          costDiscard: 1,
          then: [{ op: "token", name: "Shadow Clone" }],
          thenTargets: [],
        },
      ],
    },

    "Decree of Rage": {
      uncounterable: true,
      targets: [{
        bind: "t", spec: { type: "unit", enemy: true, domain: "calm" },
        prompt: "Deal 4 to which enemy Calm unit?",
      }],
      play: [{ op: "deal", to: "$t", n: 4 }],
    },

    "Morgana, Vindictive": {
      targets: [{
        bind: "t", spec: { type: "unit" },
        prompt: "Deal damage to which unit equal to the damage already marked on it?",
      }],
      play: [{ op: "deal", to: "$t", n: { damageOf: "$t" } }],
    },

    "Butcher of the Sands": {
      abilities: [{
        cost: { energy: 0, pips: 0, anyPower: 2, domains: null },
        label: "Add",
        exhausts: true, reaction: true, isAdd: true,
        program: [{
          op: "addResources", only: "unit",
          res: { energy: 2, pips: 0, anyPower: 0, domains: null },
        }],
      }],
    },

    "Endless Riches": {
      play: [
        { op: "banishZone", zones: ["hand", "trash"] },
        { op: "burn", n: 7 },
      ],
      skipDrawPhase: true,
      allowTrashPlay: true,
      trashToBanish: true,
    },
  });
})();
